import { TextAreaInput } from '@framework/form/inputs/TextAreaInput.tsx';
import { TextInput } from '@framework/form/inputs/TextInput.tsx';
import { RichTextAdvancedRender } from '../../../../../inputs/rich-text-advanced/render/RichTextAdvancedRender.tsx';
import { ConfigFormItem } from '../../../../../ui/form/ConfigFormItem.tsx';
import { type IWidgetComponentProps } from '../../../IWidgetType.ts';
import { getWidgetProps } from '../common/util/getWidgetProps.ts';
import { type ITextWidget, TextWidgetKind } from './ITextWidget.ts';

export interface ITextWidgetComponentProps
  extends IWidgetComponentProps<ITextWidget> {}

export function TextWidgetComponent(props: ITextWidgetComponentProps) {
  const options = getWidgetProps(props);

  const lengthRule = props.widget.rules?.lengthRange;

  return (
    <ConfigFormItem
      name={options.name}
      label={<RichTextAdvancedRender inline text={options.label} />}
      help={
        options.helpText ? (
          <RichTextAdvancedRender inline text={options.helpText} />
        ) : undefined
      }
      layout={{ hideVisualLabel: options.hideLabel }}
      readonly={options.readonly}
      widget={props.widget}
    >
      {props.widget.kind === TextWidgetKind.TextArea ? (
        <TextAreaInput
          name={options.name}
          placeholder={options.placeholder}
          value={options.value as any}
          minLength={lengthRule?.min ?? undefined}
          maxLength={lengthRule?.max ?? undefined}
          tabIndex={options.preview ? -1 : undefined}
          readOnly={props.readonly}
        />
      ) : (
        <TextInput
          name={options.name}
          placeholder={options.placeholder}
          value={options.value as any}
          minLength={lengthRule?.min ?? undefined}
          maxLength={lengthRule?.max ?? undefined}
          tabIndex={options.preview ? -1 : undefined}
          readOnly={props.readonly}
        />
      )}
    </ConfigFormItem>
  );
}
